export class ServicioLlamada {
    id_servicio : number;
    folio : string;
    fecha_creacion : any;
    folio_reporte : string;
    fecha_registro : any;
    fecha_registrostr : string;
    hora_registro : string;
    fecha_creacionstr : string;
    hora_creacion : string;
    id_registradopor : number;
    registradopor : string;
    id_tipo_atencion : number;
    tipo_atencion : string;
    id_problematica : number;
    problematica : string;
    id_motivo_atencion : number;
    motivo_atencion : string;
    id_prioridad : number;
    prioridad : string;
    id_clave_servicio : number;
    clave_servicio : string;
    id_sexo? : number;
    sexo : string;
    id_origen_llamada : number;
    origen_llamada : string;
    id_municipio : number;
    municipio : string;
    id_empresa : number;
    empresa : string;
    convenio : boolean;
    edad? : number;
    meses? : number;
    id_contacto : number;
    contacto : string;
    telefono : string;
    id_parentesco : number;
    parentesco : string;

    constructor(id_registradopor : number, registradopor : string){
        this.id_servicio = -1;
        this.folio = '-----';
        this.fecha_creacion = new Date();
        this.folio_reporte = '';
        this.fecha_registro = new Date();
        this.fecha_registrostr = this.fecha_registro.toLocaleDateString("fr-fr");
        this.hora_registro = this.fecha_registro.toLocaleTimeString("fr-fr").substring(0, 5)
        this.fecha_creacionstr = this.fecha_creacion.toLocaleDateString("fr-fr");
        this.hora_creacion = this.fecha_creacion.toLocaleTimeString("fr-fr").substring(0, 5)
        this.id_registradopor = id_registradopor;
        this.registradopor = registradopor;
        this.id_tipo_atencion = 0;
        this.tipo_atencion = '';
        this.id_problematica = 0;
        this.problematica = '';
        this.id_motivo_atencion = 0;
        this.motivo_atencion = '';
        this.id_prioridad = 0;
        this.prioridad = '';
        this.id_clave_servicio = 0;
        this.clave_servicio = '';
        this.id_sexo = null;
        this.sexo = '';
        this.id_origen_llamada = 0;
        this.origen_llamada = '';
        this.id_municipio = 0;
        this.municipio = '';
        this.id_empresa = 0;
        this.empresa = '';
        this.convenio = false;
        this.edad = null;
        this.meses = null,
        this.id_contacto = 0;
        this.contacto = '';
        this.telefono = '';
        this.id_parentesco = -1;
        this.parentesco = '';
    }
}

export class ServicioUbicacion{
    id_servicio_ubicacion : number;
    id_servicio : number;
    calle : string;
    interior? : string;
    exterior? : string;
    colonia : string;
    entrecalles? : string;
    referencia? : string;
    id_municipio : number;
    municipio : string;
    latitud : number;
    longitud : number;
    cp : number;

    constructor(id_servicio? : number){
        this.id_servicio_ubicacion = -1;
        this.id_servicio = id_servicio || -1
        this.calle = '';
        this.interior = "";
        this.exterior = "";
        this.colonia = '';
        this.entrecalles = null;
        this.referencia = null;
        this.id_municipio = -1;
        this.municipio = '';
        this.latitud = 0;
        this.longitud = 0;
        this.cp = 0;
    }
}

export class ServicioAsignacion{
    id_servicio_asignacion : number;
    id_servicio : number;
    norequiere : boolean;
    cant_unidades : number;
    cant_lesionados : number;
    tipos_unidad : Array<ServicioTipoUnidad>;

    constructor(id_servicio? : number){
        this.id_servicio_asignacion = -1;
        this.id_servicio = id_servicio || -1;
        this.norequiere = false;
        this.cant_unidades = 0;
        this.cant_lesionados = 0;
        this.tipos_unidad = new Array<ServicioTipoUnidad>();
    }
}

export class ServicioTipoUnidad{
    id_servicio_tipo_unidad : number;
    id_servicio_asignacion : number;
    id_tipo_unidad : number;
    tipo_unidad : string;

    constructor(id_servicio_asignacion? : number, id_tipo_unidad? : number){
        this.id_servicio_tipo_unidad = -1;
        this.id_servicio_asignacion = id_servicio_asignacion || -1
        this.id_tipo_unidad = id_tipo_unidad || -1
        this.tipo_unidad = '';
    }
}

export class ServicioComentario{
    id_comentario : number;
    id_servicio : number;
    comentario : string;
    fecha_registro : string;
    id_registradopor : number;
    registradopor : string;

    constructor(id_servicio? : number, fecha_registro? : string, id_registradopor? : number, registradopor? : string){
        this.id_comentario = -1;
        this.id_servicio = id_servicio || -1;
        this.fecha_registro = fecha_registro || new Date().toLocaleDateString("fr-fr");
        this.id_registradopor = id_registradopor || -1;
        this.registradopor = registradopor || null;
    }   
}

export class ServicioLesionado{
    id_lesionado : number;
    id_servicio : number;
    id_sexo? : number;
    id_prioridad : number;
    nombre : string;
    edad : number;
    meses:number;

    constructor(id_servicio? : number){
        this.id_lesionado = -1;
        this.id_servicio = id_servicio || -1;
        this.id_sexo = null;
        this.id_prioridad = null;
        this.nombre = "";
        this.edad = 0;
        this.meses = 0;
    }
}

export class ServicioAntecedente{
    id_servicio_antedecente : number;
    id_servicio : number;
    riesgo : boolean;
    enfermedades : string;
    medicamentos : string;
    eventos : string;
    prediagnostico:string;
    rechaza_atencion:boolean;

    constructor(id_servicio? : number){
        this.id_servicio_antedecente = -1;
        this.id_servicio = id_servicio || -1;
        this.riesgo = null;
        this.enfermedades = "";
        this.medicamentos = "";
        this.eventos = "";
        this.prediagnostico = "";
        this.rechaza_atencion = false;
    }
}

export class ServicioAntecedenteComentarios{
    id_comentario : number;
    id_servicio_antecedente : number;
    comentario : string;
    fecha_registro : string;
    id_registradopor : number;
    registradopor : string;

    constructor(id_servicio_antecedente? : number, fecha_registro? : string, id_registradopor? : number, registradopor? : string){
        this.id_comentario = -1;
        this.id_servicio_antecedente = id_servicio_antecedente || -1;
        this.fecha_registro = fecha_registro || new Date().toLocaleDateString("fr-fr");
        this.id_registradopor = id_registradopor || -1;
        this.registradopor = registradopor || null;
    }   
}